import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import composedMyAssignmentsContainer from "../../../containers/MyAssignmentsContainer";
// import MyAssignementList from "./MyAssignementsList";
// import MyAssignmentCompletedList from "./MyAssignmentCompletedList";
// import MyAssignmentCancelledList from "./MyAssignmentCancelledList";
import { useEffect } from "react";
// import CancelAssignments from "./CancelAssignments";
// import MyAssignmentListMobile from "./MyAssignmentListMobile";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Speed Dial - Start
import Box from "@mui/material/Box";
import { connect } from "react-redux";
import PendingSwipeInOrOutAssignments from "../SwipeInOrSwipeOut/PendingSwipeInOrOutAssignments";
import MainSwipeInOrOutDetails from "../SwipeInOrSwipeOut/MainSwipeInOrOutDetails";
import { redirectUrl } from "../../../services/GlobalUrls";
import Swal from "sweetalert2";

const ShiftAttendanceDetails = ({
  normalizedCategory,
  deviceInfo,
  ...props
}) => {
  const [shiftAttendanceDetails, setShiftAttendanceDetails] = useState([]);
  const [loaderDone, setLoaderDone] = useState(false);
  const [isCheckingAccess, setIsCheckingAccess] = useState(true);

  useEffect(() => {
    // Fetch shift attendance details from props or API
    if (props.myCurrentRunningAssignments) {
      const filteredAndSorted = props.myCurrentRunningAssignments
        // Remove rows that have both swipe_in_details and swipe_out_details
        .filter((item) => !(item.swipe_in_details && item.swipe_out_details))
        .sort((a, b) => {
          const getDateTimeRange = (item) => {
            const baseDate = item.cnd_assignment_availability_date;

            const start = new Date(
              `${baseDate}T${item.cnd_assignment_start_time}`,
            );
            let end = new Date(`${baseDate}T${item.cnd_assignment_end_time}`);

            // If end time is less than or equal to start time, it's next day
            if (end <= start) {
              end.setDate(end.getDate() + 1);
            }

            return { start, end };
          };

          const aTime = getDateTimeRange(a);
          const bTime = getDateTimeRange(b);

          if (aTime.start.getTime() === bTime.start.getTime()) {
            return aTime.end - bTime.end;
          }

          return aTime.start - bTime.start;
        });

      // Add "show_button": "yes" to the first item if it exists
      if (filteredAndSorted.length > 0) {
        filteredAndSorted[0] = {
          ...filteredAndSorted[0],
          show_button: "yes",
        };
      }

      setShiftAttendanceDetails(filteredAndSorted);
      setTimeout(() => {
        setLoaderDone(true);
      }, 2000); // 4000ms = 4 seconds
      // setLoaderDone(true);
    } else {
      // Placeholder for fetching data from an API or other source
      setShiftAttendanceDetails([]);
      setTimeout(() => {
        setLoaderDone(true);
      }, 2000);
    }
  }, [props.myCurrentRunningAssignments]);

  // useEffect(() => {
  //   if (!normalizedCategory) {
  //     return;
  //   }

  //   if (normalizedCategory === "home care") {
  //     setIsCheckingAccess(false);
  //     return;
  //   }

  //   const timer = setTimeout(async () => {
  //     setLoaderDone(false);
  //     await Swal.fire({
  //       icon: "warning",
  //       title: "Access Denied",
  //       text: "This page is not accessible for your account.",
  //       confirmButtonText: "OK",
  //     });
      
  //     redirectUrl("/dashboard");
  //   }, 500);

  //   return () => clearTimeout(timer);
  // }, [normalizedCategory]);

  return (
    <React.Fragment>
      <div className="job-bx submit-resume" id="scrollFocusElement">
        <div className="job-bx-title clearfix">
          <h5 className="font-weight-700 pull-left text-uppercase">
            Shift Attendance
          </h5>
        </div>

        {loaderDone == true ? (
          <form className="attach-resume">
            {/* <pre>{JSON.stringify(curretAssinmentIndividualData, null, 2)}</pre> */}
            <MainSwipeInOrOutDetails
              curretAssinmentIndividualData={shiftAttendanceDetails}
              setShiftAttendanceDetails={setShiftAttendanceDetails}
              setLoaderDone={setLoaderDone}
              deviceInfo={deviceInfo}
            />
            {shiftAttendanceDetails.length === 0 && (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <div className="alert alert-info">
                      No pending shift attendance details found.
                    </div>
                  </div>
                </div>
              </>
            )}
          </form>
        ) : (
          <div className="text-center">
            <h1 style={{ fontSize: "80px" }}>
              <i className="fa fa-spinner fa-pulse text-primary"></i>
            </h1>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userAuth: state.auth.authUserData,
    userData: state.userProfile.userData,
    myCurrentRunningAssignments:
      state.myCurrentRunningAssignments.myCurrentRunningAssignments,
    progress: state.progress.progress,
  };
};

export default connect(mapStateToProps)(ShiftAttendanceDetails);
